let dirPath = 'games/page007_game3/';

let configGame = {
  removeInCorrects: true,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  rulesGame: {
    groupsConfig: {},
    itemsGarbage: [{ idGroup: 'source', itemsConfig: { block: false, shuffle: false } }],
    itemsConfig: { shuffle: false, block: true },
    otherProperty: {
      sounds: [{ src: dirPath + 'audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'target',
        idItem: '00',
        correct: [{ idGroup: 'source', idItem: 's03' }],
      },
      {
        idGroup: 'target',
        idItem: '01',
        correct: [{ idGroup: 'source', idItem: 's01' }],
      },
      {
        idGroup: 'target',
        idItem: '02',
        correct: [{ idGroup: 'source', idItem: 's04' }],
      },
      {
        idGroup: 'target',
        idItem: '03',
        correct: [{ idGroup: 'source', idItem: 's04' }],
      },
      {
        idGroup: 'target',
        idItem: '04',
        correct: [{ idGroup: 'source', idItem: 's01' }],
      },
      {
        idGroup: 'target',
        idItem: '05',
        correct: [{ idGroup: 'source', idItem: 's03' }],
      },
      {
        idGroup: 'target',
        idItem: '06',
        correct: [{ idGroup: 'source', idItem: 's01' }],
      },
      {
        idGroup: 'target',
        idItem: '07',
        correct: [{ idGroup: 'source', idItem: 's02' }],
      },
      {
        idGroup: 'target',
        idItem: '08',
        correct: [{ idGroup: 'source', idItem: 's02' }],
      },
      {
        idGroup: 'target',
        idItem: '09',
        correct: [{ idGroup: 'source', idItem: 's01' }],
      },
      {
        idGroup: 'target',
        idItem: '10',
        correct: [{ idGroup: 'source', idItem: 's01' }],
      },
    ],
  },
  layout: {
    itemsConfig: {
      background: {
        text: {
          textBaseline: 'middle',
          textAlign: 'center',
        },
      },
    },
    groups: [
      {
        idGroup: 'target',
        positions: {
          pos: { autoFit: true },
          type: 'absolute',
          fixTab: [
            { x: 725, y: 110 }, // 10
            { x: 413, y: 110 }, // 00
            { x: 309, y: 735 }, // 01
            { x: 725, y: 319 }, // 02
            { x: 516, y: 527 }, // 03
            { x: 725, y: 735 }, // 04
            { x: 829, y: 526 }, // 05
            { x: 1037, y: 526 }, // 06
            { x: 1037, y: 319 }, // 07
            { x: 1142, y: 214 }, // 08
            { x: 1037, y: 110 }, // 09
          ],
        },
        itemsConfig: {
          background: {
            color: 'rgba(255, 255, 255, 0.01)',
            text: {
              font: 'Myriad Pro',
              size: '36px',
              bold: true,
            },
          },
        },
        otherProperty: {
          hooks: {
            background: { color: 'transparent' },
            positions: {
              pos: { width: 67, height: 67, y: 0 },
              columns: 1,
            },
          },
        },
        items: [
          {
            id: '00',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '01',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '02',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '03',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '04',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '05',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '06',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '07',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '08',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '09',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
          {
            id: '10',
            otherProperty: {
              hooks: {
                items: [{ id: 'h01', background: { color: 'rgba(255, 255, 255, 0.01)' } }],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        itemsConfig: {
          positions: { pos: { height: 67, width: 67, x: 1448, y: 147 }, columns: 1, margin: { left: 10, top: 16 } },
          background: {
            color: 'rgba(255, 255, 255, 0.01)',
            text: { size: '27px', textAlign: 'center', textBaseline: 'middle', lineWidth: 300, font: 'Myriad Pro' },
          },
        },
        otherProperty: {
          clones: {
            cloneNumber: 6,
          },
        },
        items: [
          {
            id: 's01',
            background: {
              image: { src: dirPath + 'img/right.png', pos: { x: 0, y: 0, width: 67, height: 67 } },
            },
          },
          {
            id: 's02',
            background: {
              image: { src: dirPath + 'img/bottom.png', pos: { x: 0, y: 0, width: 67, height: 67 } },
            },
          },
          {
            id: 's03',
            background: {
              image: { src: dirPath + 'img/left.png', pos: { x: 0, y: 0, width: 67, height: 67 } },
            },
          },
          {
            id: 's04',
            background: {
              image: { src: dirPath + 'img/top.png', pos: { x: 0, y: 0, width: 67, height: 67 } },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  realHeight: 800,
  realWidth: 1800,
  mainImage: {
    imagePath: 'informatyka/games/page007_game3/img/plansza.png',
    pos: {
      x: 0,
      y: 0,
    },
    width: 1920,
    height: 1080,
  },
  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
